import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/products/ProductInfo.tsx");
